import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getTracking,
    getDriverTracking,
}

function getTracking(query) {
    return request('get', `${HOST_API}/drivers/tracking`, query)
}

function getDriverTracking(driverId, query) {
    return request('get', `${HOST_API}/drivers/${driverId}/tracking`, query)
}

function request(method, url, query) {
    return new Promise((resolve) => {
        Superagent[method](url)
            .set('access', Storage.getItem('access'))
            .query(query || {})
            .end((err, res) => {
                const body = res && res.body
                    ? res.body
                    : { success: false, error: { message: 'No se pudo consultar el seguimiento' } }
                Access(body)
                resolve(body)
            })
    })
}
